
import { Routes, RouterModule } from '@angular/router';

import { AuthComponent } from './auth/auth.component';
import { PublicComponent } from './public/public.component';
import { SettingsComponent } from './settings/settings.component';
import { VisualizadorComponent } from './modules/visualizador/visualizador.component';
import {RoleGuardService} from './services/role-guard.service';
export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'register',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'register',
        loadChildren: './auth/register/register.module#RegisterModule'
      },
      {
        path: 'recovery',
        loadChildren: './auth/recovery/recovery.module#RecoveryModule'
      }
    ]
  },
  {
    path: '',
    component: PublicComponent,
    children: [
      {
        path: 'intro',
        loadChildren: './public/intro/intro.module#IntroModule'
      },
      {
        path: 'realizadores',
        loadChildren: './public/producer/producer.module#ProducerModule'
      },
      {
        path: 'empresas',
        loadChildren: './public/companies/companies.module#CompaniesModule'
      },
      {
        path: 'educadores',
        loadChildren: './public/educators/educators.module#EducatorsModule'
      }
    ]
  },
  {
    path: 'painel',
    children: [
    {
      path: '',
      loadChildren: './settings/dashboard-client/lele/lele.module#LeleModule'
    },
    {
      path: 'loja',
      loadChildren: './settings/dashboard-client/store/store.module#StoreModule'
    }
    ]
  },
  {
    path: 'dashboard',
    component: SettingsComponent,
    children: [
      {
        path: 'empresas',
        loadChildren: './settings/dashboard-companies/dashboard-companies.module#DashboardCompaniesModule'
      },
      {
        path: 'educadores',
        loadChildren: './settings/dashboard-educators/dashboard-educators.module#DashboardEducatorsModule'
      },
      {
        path: 'helpdesk',
        loadChildren: './public/helpdesk/helpdesk.module#HelpdeskModule'
      },
    ]
  },
  {
  path: 'visualizador',
  canActivate: [RoleGuardService],
  component: VisualizadorComponent,
  children: [{
    path: '',
    loadChildren: './modules/visualizador/visualizador.module#VisualizadorModule'
  }]
},
];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts